import { render, staticRenderFns } from "./selectProject.vue?vue&type=template&id=66c43e5c&scoped=true&"
import script from "./selectProject.vue?vue&type=script&lang=js&"
export * from "./selectProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c43e5c",
  null
  
)

export default component.exports